import script from "./ListExercises.vue?vue&type=script&setup=true&lang=js"
export * from "./ListExercises.vue?vue&type=script&setup=true&lang=js"

import "./ListExercises.vue?vue&type=style&index=0&id=429a3858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-429a3858"]])

export default __exports__